import * as actionType from '../actions/ActionType';
import initialState from "./initialState";

export default function reducer(state, action) {
  state = state || initialState;

  switch (action.type) {
    case actionType.SET_LOADING_STATE:
      return { ...state, isLoading: action.isLoading };
    case actionType.SET_RECAPTCHA_RESPONSE:
          return { ...state, recaptchaResponse: action.recaptchaResponse };
    case actionType.SET_LIMAN:
      return { ...state, limanId: action.limanId };
    case actionType.GET_LIMANLAR:
      return { ...state, limanlar: action.limanlar };
    case actionType.WILL_GET_ALL:
      return { ...state, willGetAll: action.willGetAll };
    case actionType.SET_BASLANGIC_TARIHI:
      return { ...state, baslangicTarihi: action.baslangicTarihi };
    case actionType.SET_BITIS_TARIHI:
      return { ...state, bitisTarihi: action.bitisTarihi };
    case actionType.SET_TICARET_TIPI:
      return { ...state, ticaretTipi: action.ticaretTipi };
    case actionType.SET_GEMİ_ADI:
      return { ...state, gemiAdı: action.gemiAdı };
    case actionType.KUR_GUNCELLE:
      return { ...state, guncelKur: action.guncelKur };
    case actionType.SET_SEFERLER:
      return { ...state, seferler: action.seferler };
    case actionType.SET_SEFER_FRW_LIST:
      return { ...state, seferFrwList: action.seferFrwList };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.js